import * as React from 'react'
import { Button } from 'semantic-ui-react'
import './gradient-overlay.css'

const LimitedWithGradient = class extends React.Component {
    state = {
      collapsed: true,
    }

    render() {
      const collapsedStyle = {
        height: 500,
        overflow: 'hidden',
      }

      return <div style={{textAlign: 'center'}}>
        <div
          className={this.state.collapsed ? 'gradient-overlay' : null}
          style={this.state.collapsed ? collapsedStyle : null}>
          {this.props.children}
        </div>
        {this.state.collapsed ? <Button positive
          style={{ marginTop: 33 }}
          onClick={() => {
            this.setState({collapsed: false})
          }}>
          Ver mais
        </Button> : null}
      </div>
    }
  }

  export default LimitedWithGradient
